import { gql } from "@apollo/client";

export const GET_NOTIFICACIONES = gql`
query GetVisitaNotificaciones($idEvaluacion: Int!) {
    visitaNotificaciones(idEvaluacion: $idEvaluacion) {
        idPaciente
        paciente
        estadoPaciente
        idEvaluacion
        programa
        plan
        notificaciones {
            idNotificacion
            fechaNotificacion
            idEmisor
            emisor
            idReceptor
            receptor
            observacion
            tipo      
        }    
    }
}`;